import { BACK_OFFICE_TEAM } from "../data/backOffice";
import { Mail, Phone } from "lucide-react";

export const BackOfficeSection = () => {
  return (
    <section className="relative py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#F4F7FC] to-white" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0F1B3D]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", lineHeight: '1.25' }}>
            Back office tým
          </h2>
          <p className="mt-4 text-lg text-[#4A5B7A]" style={{ fontFamily: "'Inter', sans-serif" }}>
            Lidé, které slyšíte v telefonu
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {BACK_OFFICE_TEAM.map((member) => (
            <div key={member.email} className="bg-white rounded-3xl p-6 border border-[#E8EDF5] hover:border-[#0049B3]/15 hover:shadow-xl transition-all duration-500 text-center">
              <div className="mb-4 flex justify-center">
                {member.photo ? (
                  <img src={member.photo} alt={member.name} className="w-20 h-20 rounded-full object-cover ring-4 ring-white shadow-lg" />
                ) : (
                  <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#0049B3] to-[#2B7AE0] flex items-center justify-center ring-4 ring-white shadow-lg">
                    <span className="text-white font-bold text-lg">{member.name.split(' ').map(w => w[0]).join('')}</span>
                  </div>
                )}
              </div>
              <h3 className="text-base font-bold text-[#0F1B3D] mb-3" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{member.name}</h3>
              <div className="space-y-1.5">
                <a href={`mailto:${member.email}`} className="flex items-center justify-center gap-2 text-xs text-[#0049B3] hover:text-[#003380] transition-colors">
                  <Mail className="w-3.5 h-3.5" /><span className="truncate">{member.email}</span>
                </a>
                <a href={`tel:${member.phone.replace(/\s/g, '')}`} className="flex items-center justify-center gap-2 text-xs text-[#0049B3] hover:text-[#003380] transition-colors">
                  <Phone className="w-3.5 h-3.5" /><span>{member.phone}</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
